'use client';

import { useEffect, useRef, useState } from 'react';
import { useRouter } from 'next/navigation';

export default function RegistrySearch() {
  const [searchQuery, setSearchQuery] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);
  const router = useRouter();

  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      // Check for Cmd+K (Mac) or Ctrl+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key === 'k') {
        e.preventDefault();
        inputRef.current?.focus();
      }

      // Handle Escape to blur
      if (e.key === 'Escape') {
        inputRef.current?.blur();
        setSearchQuery('');
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, []);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      router.push(`/registry?search=${encodeURIComponent(searchQuery.trim())}`);
    } else {
      router.push('/registry');
    }
  };

  return (
    <form onSubmit={handleSearch} className="mb-8">
      <div className="relative max-w-2xl mx-auto">
        <div className="flex items-center gap-3 px-4 py-3 bg-gray-50 border border-gray-200 rounded-lg focus-within:border-lime-400 focus-within:ring-2 focus-within:ring-lime-200 transition-all">
          <svg className="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
          </svg>
          <input
            ref={inputRef}
            type="text"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            placeholder="Search for security rules..."
            className="flex-1 bg-transparent border-none outline-none text-gray-900 placeholder-gray-400"
            style={{ color: '#111827' }}
          />
          <kbd className="hidden sm:inline-block text-sm text-gray-400 bg-gray-100 px-2 py-1 rounded font-mono">
            ⌘K
          </kbd>
        </div>
      </div>
    </form>
  );
}
